import React, { lazy, Suspense } from 'react'
import { useOverlay, useInfoSheet } from '@fs/zion-ui'
import { Menu } from '@fs/zion-icon'
import { useTranslation } from 'react-i18next'
import HeaderIconButton from '../../../shared/components/HeaderIconButton'
import MobileDrawer from './MobileDrawer'

const HelperDialog = lazy(() => import('../shared/HelperDialogIntermediate'))

export default function MobileDrawerButtonCombo({ activeRole, breakMode, ...props }) {
  const { t } = useTranslation()
  const infoSheet = useInfoSheet()
  const helpOthersOverlay = useOverlay()

  if (breakMode !== 'mobile') {
    return null
  }

  return (
    <>
      <HeaderIconButton
        onClick={infoSheet.handleClick}
        Icon={Menu}
        title={t('header.open-menu.action', 'Open Menu')}
        data-test-id="hdr_open_mobile_menu"
      />
      <MobileDrawer helpOthersOverlay={helpOthersOverlay} activeRole={activeRole} infoSheet={infoSheet} {...props} />
      <Suspense fallback="">
        {helpOthersOverlay.isOpen && <HelperDialog overlay={helpOthersOverlay} adminActiveRole={activeRole} />}
      </Suspense>
    </>
  )
}
